import { getOfficeConsent } from './GetOfficeConsent';
import { acceptAllOfficeConsents } from './AcceptAllOfficeConsents';

export const ConsentsClient = {
  getOfficeConsent,
  acceptAllOfficeConsents,
};
